import { useQuery } from "@tanstack/react-query";

import { PartnershipsParams, getPartnerships } from "../../services/productPlaneApi";
import { queryKeys } from "./keys";

const STALE_TIME = 60 * 1000;
const GC_TIME = 5 * 60 * 1000;

/**
 * TanStack Query hook for the organizations that work together on a
 * selection's products.
 *
 * The caller builds the request and says whether it is ready to read. An
 * unknown organization in focus fails with a 404, which is not retried.
 */
export function usePartnerships(params: PartnershipsParams, enabled = true) {
  return useQuery({
    queryKey: queryKeys.productPlane.partnerships(params),
    queryFn: () => getPartnerships(params),
    enabled,
    staleTime: STALE_TIME,
    gcTime: GC_TIME,
    retry: (count, error) =>
      (error as { response?: { status?: number } } | null)?.response?.status !==
        404 && count < 2,
  });
}
